require('./brokerProductFiltersCollapsed.scss');
const { taggingEventHandled } = require('utilities/taggingEventHandled');
// @vendor
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const { FormattedText } = require('core/i18n').i18n;

// @commons
const { OKButton } = require('components/commons/OKButton/OKButton');

// @ constants
const {
    BROKER_PRODUCT_ADVANCED_SEARCH_TERM,
    BROKER_PRODUCT_ADVANCED_SEARCH_CURRENCY,
    BROKER_PRODUCT_ADVANCED_SEARCH_ASSET_TYPES,
    BROKER_PRODUCT_ADVANCED_SEARCH_RISK,
    BROKER_PRODUCT_ADVANCED_SEARCH_SUB_ASSET_TYPE,
    BROKER_PRODUCT_ADVANCED_SEARCH_MARKET,
    BROKER_PRODUCT_ADVANCED_SEARCH_MANAGER,
    BROKER_PRODUCT_ADVANCED_SEARCH_PRODUCT_TYPES,
    BROKER_PRODUCT_ADVANCED_SEARCH_ALL_OPTIONS,
    MYPROFILE_BROKER_EXPLORE_URL,
    BROKER_ADVANCED_SEARCH_UTAG_NAME
} = require('constants/index');

class BrokerProductFiltersCollapsed extends React.Component {
    constructor(props) {
        super(props);
        this.handleSearchEditButton = this.handleSearchEditButton.bind(this);
    }

    handleSearchEditButton() {
        taggingEventHandled(BROKER_ADVANCED_SEARCH_UTAG_NAME, 'editAdvanceSearch');
        const { history, immBrokerProductFiltersSearch } = this.props;
        const productType = immBrokerProductFiltersSearch.get('isOnlyOneProductSelected') ?
                        `/${immBrokerProductFiltersSearch.get('onlyOneProductTypeSelected').toLowerCase()}` :
                        '';
        history.push(`${MYPROFILE_BROKER_EXPLORE_URL}${productType}`);
    }

    getMultipleLabels(list, type) {
        let results;
        if(list.size) {
            if (list.size === 1) {
                results = list.get(0).label;
            } else {
                results = `${list.get(0).label}, +${list.size -1}`;
            }
            return (
                <span className="broker-product-filters-collapsed__pill-strong">
                    {results}
                </span>
            )
        } else {
            return (
                <span className="broker-product-filters-collapsed__pill">
                    <FormattedText value={`brokerAdvancedSearch-brokerAdvancedSearch_${type}AllLabel`} />
                </span>
            )
        }
    }

    getLabel(array, type) {
        if (array.label && array.value !== BROKER_PRODUCT_ADVANCED_SEARCH_ALL_OPTIONS) {
            return (
                <span className="broker-product-filters-collapsed__pill-strong">
                    {array.label}
                </span>
            )
        } else {
            return (
                <span className="broker-product-filters-collapsed__pill">
                    <FormattedText value={`brokerAdvancedSearch-brokerAdvancedSearch_${type}AllLabel`} />
                </span>
            )
        }
    }

    getIsinLabel() {
        const { immBrokerProductFiltersSearch } = this.props;
        const isinLabel = immBrokerProductFiltersSearch.getIn(['search', BROKER_PRODUCT_ADVANCED_SEARCH_TERM]);

        if (isinLabel) {
            const ellipsis = isinLabel.length > 4 ? '...' : '';
            return (
                <span className="broker-product-filters-collapsed__pill-strong">
                    {isinLabel.substring(0,4) + ellipsis}
                </span>
            );
        }

        return null;
    }

    render() {
        const { immBrokerProductFiltersSearch } = this.props;
        const assetTypes = this.getMultipleLabels(immBrokerProductFiltersSearch.getIn(['search', BROKER_PRODUCT_ADVANCED_SEARCH_ASSET_TYPES]), BROKER_PRODUCT_ADVANCED_SEARCH_ASSET_TYPES);
        const subAssetTypes = this.getLabel(immBrokerProductFiltersSearch.getIn(['search', BROKER_PRODUCT_ADVANCED_SEARCH_SUB_ASSET_TYPE]), BROKER_PRODUCT_ADVANCED_SEARCH_SUB_ASSET_TYPE);
        const currencyTypes = this.getLabel(immBrokerProductFiltersSearch.getIn(['search', BROKER_PRODUCT_ADVANCED_SEARCH_CURRENCY]), BROKER_PRODUCT_ADVANCED_SEARCH_CURRENCY);
        const riskTypes = this.getLabel(immBrokerProductFiltersSearch.getIn(['search', BROKER_PRODUCT_ADVANCED_SEARCH_RISK]), BROKER_PRODUCT_ADVANCED_SEARCH_RISK);
        const managerTypes = this.getLabel(immBrokerProductFiltersSearch.getIn(['search', BROKER_PRODUCT_ADVANCED_SEARCH_MANAGER]), BROKER_PRODUCT_ADVANCED_SEARCH_MANAGER);
        const marketTypes = this.getLabel(immBrokerProductFiltersSearch.getIn(['search', BROKER_PRODUCT_ADVANCED_SEARCH_MARKET]), BROKER_PRODUCT_ADVANCED_SEARCH_MARKET);
        const productTypes = this.getMultipleLabels(immBrokerProductFiltersSearch.getIn(['search', BROKER_PRODUCT_ADVANCED_SEARCH_PRODUCT_TYPES]), BROKER_PRODUCT_ADVANCED_SEARCH_PRODUCT_TYPES);
        const isinTypes = this.getIsinLabel();
        return (
            <div className="broker-product-filters-collapsed">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="broker-product-filters-collapsed__pills-container col-sm-8">
                            {isinTypes}
                            {assetTypes}
                            {subAssetTypes}
                            {productTypes}
                            {currencyTypes}
                            {riskTypes}
                            {marketTypes}
                            {managerTypes}
                        </div>
                        <div className="broker-product-filters-collapsed__edit-button col-sm-4">
                            <OKButton
                                modifier="ghost"
                                loading={false}
                                onClick={() => this.handleSearchEditButton()}
                            >
                                <i className="icon-s-editar broker-product-filters-collapsed__edit-button-link"></i>
                                <FormattedText value="brokerAdvancedSearch-brokerAdvancedSearch_advancedSearchEditButton" />
                            </OKButton>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

BrokerProductFiltersCollapsed.propTypes = {
    history: PropTypes.object.isRequired,
    immBrokerProductFiltersSearch: PropTypes.object.isRequired,
    editSearch: PropTypes.func.isRequired
};

BrokerProductFiltersCollapsed.defaultProps = {
    editSearch: () => { return false }
}

module.exports.constructor = BrokerProductFiltersCollapsed;
module.exports.BrokerProductFiltersCollapsed = connect(
    state => ({
        immBrokerProductFiltersSearch: state.brokerProductFiltersSearch
    }),{
    }
)(withRouter(BrokerProductFiltersCollapsed));
